// Polyfills for browser environment
import 'buffer';
import 'stream-browserify';
import 'crypto-browserify';

// Ensure global process object is available
if (typeof window !== 'undefined' && !window.process) {
  window.process = {
    env: {},
    browser: true,
    version: '',
    nextTick: fn => setTimeout(fn, 0)
  };
}

if (typeof window !== 'undefined' && window.process && window.process.env && window.process.env.NODE_ENV === 'development') {
  console.log('Polyfills loaded successfully');
} 